import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

const useQueryParams = (config?: any) => {
  return queryString.parse(useLocation().search, config);
};

export default useQueryParams;
